import { render, staticRenderFns } from "./format-b.vue?vue&type=template&id=eda7739a&scoped=true&"
import script from "./format-b.vue?vue&type=script&lang=js&"
export * from "./format-b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda7739a",
  null
  
)

export default component.exports